import Http from "../../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../../core/HttpResponse";
import { Form_Create_Invoice } from "../../form/retur/FormRetur";
import { M_Invoice, M_InvoiceDetail } from "../../type/Invoice.type";

export interface Http_GET_Invoice extends HttpBaseRequest {
  start_date?: string;
  end_date?: string;
  customer_name?: string;
  invoice_type?: string;
  sub_dealer_id?: string;
  payment_method_id?: string;
  status?: string;
}

export const addInvoice = async ({
  customer_name,
  invoice_status,
  invoice_date,
  invoice_type,
  payment_method_id,
  product_list,
  customer_address,
  customer_phone_number,
  payment_due_date,
  sub_dealer_id,
  description,
}: Form_Create_Invoice) => {
  const result = await Http.post({
    url: "/invoice/insert",
    data: {
      customer_name,
      invoice_status,
      invoice_date,
      invoice_type,
      payment_method_id,
      product_list,
      customer_address,
      customer_phone_number,
      payment_due_date,
      sub_dealer_id,
      description,
    },
  });
  return result;
};

export const payInvoice = async ({
  invoice_id,
  payment_method_id,
}: {
  invoice_id: string;
  payment_method_id: string;
}) => {
  const result = await Http.post({
    url: "/invoice/pay",
    data: {
      invoice_id,
      payment_method_id,
    },
  });
  return result;
};

export const getInvoices = async ({
  customer_name,
  end_date,
  invoice_type,
  keyword,
  page,
  payment_method_id,
  perPage,
  start_date,
  status,
  sub_dealer_id,
}: Http_GET_Invoice) => {
  const result = await Http.get<HttpBaseResponse<HttpData<M_Invoice[]>>>({
    url: "/invoice",
    params: {
      customer_name,
      end_date,
      invoice_type,
      keyword,
      page,
      payment_method_id,
      perPage,
      start_date,
      status,
      sub_dealer_id,
    },
  });
  return result;
};

export const getInvoice = async ({ invoice_id }: { invoice_id?: string }) => {
  const result = await Http.get<HttpBaseResponse<M_InvoiceDetail>>({
    url: "/invoice/detail",
    params: {
      invoice_id,
    },
  });
  return result;
};

export const cancelInvoice = async ({
  invoice_id,
  description,
}: {
  invoice_id: string;
  description: string;
}) => {
  const result = await Http.post({
    url: "/invoice/cancel",
    data: {
      invoice_id,
      description,
    },
  });
  return result;
};
